<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    methods: {
        ...mapActions({
            signOut: 'auth/signOut',
        }),

        ...mapMutations({
            setOverlay: 'auth/setOverlay',  
            setAuthenticated: 'auth/setAuthenticated',       
        }),

        async logOut () {
            console.log('loging out...');            
            this.setOverlay(true);
            try{
                await this.signOut();
            } catch (error) {
                console.log(error);
            } finally{
                this.setOverlay(false);
                sessionStorage.clear();
                this.setAuthenticated(false);
                this.$router.replace('/')
                
            }           
        }

        
    }
}
</script>